import React from 'react';

const Layout=(props)=>{
	return (
		<React.Fragment>
			{props.children.map((content,i)=>(<div key={i}>{i===props.children.length-1?React.cloneElement(content,{last:true}):content}</div>))}
		</React.Fragment>
	);
}

export default Layout;
